module.exports = __webpack_public_path__ + "static/media/MALAK ALLTFO.22eb471d.png";